export default __webpack_public_path__ + "static/media/nbmon-background.35ccc918.png";